import { selectConfigurationAdditionalData } from '../../../selectors';
// Shown in place of a pose picker when the slot being configured has no source
// images to offer. Shared by the regular config picker
// (BackgroundsPosesSelector/PosesConfig) and the multi-config child picker
// (MultiConfig) so the two flows cannot drift apart.
//
// A slot's pose source is decided by its record type — group slots read
// `studentGroupImages`, individual slots read the individual gallery, and a
// group slot deliberately never falls back to the individual one (see
// selectTransformedPoses). When that source is empty there is nothing to pick,
// so we say which kind of photo is missing rather than render an empty grid.
// Whether a slot is fillable at all lives in `selectPoseSlotsFillable`; the slot
// navigator skips unfillable slots, so this is reached by tapping such a slot's
// tile directly.
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Message = styled.div`
  padding: 24px 12px;
  text-align: center;
  font-size: 16px;
  color: #555555;
`;

// "Jamie Smith" from either camelCase or snake_case fields, falling back to a
// generic label when the name is unknown.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const studentDisplayName = (selectedStudent: any): string => {
  const firstName =
    selectedStudent?.firstName || selectedStudent?.first_name || null;
  const lastName =
    selectedStudent?.lastName || selectedStudent?.last_name || null;

  return firstName && lastName ? `${firstName} ${lastName}` : 'your student';
};

interface NoPoseImageMessageProps {
  // The record type of the slot with nothing to show.
  slotIsGroup: boolean;
}

const NoPoseImageMessage: React.FC<NoPoseImageMessageProps> = ({
  slotIsGroup,
}) => {
  const selectedStudent = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => selectConfigurationAdditionalData(state)?.selectedStudent,
  );
  const studentName = studentDisplayName(selectedStudent);

  return (
    <Message>
      {slotIsGroup
        ? `No group image available for ${studentName}`
        : `No individual photos available for ${studentName}`}
    </Message>
  );
};

export default NoPoseImageMessage;
